import GroupCreateModalBase from '../../2compounds/GroupCreateModalBase'
import {useEffect, useState} from 'react'
import {deepCopyObjectArray} from '../../../services/util/miscellaneousService'
import FeatureSetSearch from '../../2compounds/FeatureSetSearch'

const SelectFeatureSetModal = ({open, setOpen, featureSets, setFeatureSets}) => {
    const [featureSetsTemp, setFeatureSetsTemp] = useState([])

    const cancelHandler = () => {
        setOpen(false)
    }

    const saveHandler = () => {
        const featureSetsTempCopy = [...featureSetsTemp]
        setFeatureSets(featureSetsTempCopy)
        setOpen(false)
    }

    useEffect(()=>{
        const deepCopiedFeatureSets = deepCopyObjectArray(featureSets)
        setFeatureSetsTemp(deepCopiedFeatureSets)
    }, [featureSets, open])

    return (
        <GroupCreateModalBase header='Assign feature sets'
                              saveHandler={saveHandler}
                              cancelHandler={cancelHandler}
                              open={open}
                              setOpen={setOpen}>
            <FeatureSetSearch featureSets={featureSetsTemp}
                              setFeatureSets={setFeatureSetsTemp} />
        </GroupCreateModalBase>
    )
}

export default SelectFeatureSetModal
